import { createSlice } from "@reduxjs/toolkit";

export const release = createSlice({
  name: "releaseTabs",
  initialState: {
    currentTabs: 0,
  },

  reducers: {
    updateReleaseTabs: (state = release?.initialState, action) => {
      state.currentTabs = action.payload;
    },
  },
});
export const { updateReleaseTabs } = release.actions;
export default release.reducer;
